"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementPendingClassMetadataCount = incrementPendingClassMetadataCount;
const reflect_metadata_utils_1 = require("@inversifyjs/reflect-metadata-utils");
const pendingClassMetadataCountReflectKey_1 = require("../../reflectMetadata/data/pendingClassMetadataCountReflectKey");
const getDefaultPendingClassMetadataCount_1 = require("../calculations/getDefaultPendingClassMetadataCount");
function incrementPendingClassMetadataCount(type) {
    return (metadata) => {
        if (metadata === undefined) {
            (0, reflect_metadata_utils_1.updateOwnReflectMetadata)(type, pendingClassMetadataCountReflectKey_1.pendingClassMetadataCountReflectKey, getDefaultPendingClassMetadataCount_1.getDefaultPendingClassMetadataCount, (count) => count + 1);
        }
    };
}
//# sourceMappingURL=incrementPendingClassMetadataCount.js.map